module.exports = __webpack_public_path__ + "static/media/ItemSent.b9ea6959.svg";